import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


const userDefaults = {
    uid: 0,          // From Auth
    displayName: "John Doe", // From Auth
    about: "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
    photoURL: require("@/assets/images/portrait/small/user-avatar.png"), // From Auth
    status: "online",
    userRole: "admin"
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser: userDefaults,
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    mainLayoutType: themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList: navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: "default",
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme: themeConfig.theme || "light",
    themePrimaryColor: colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    userInformation: {},
    isUpdateOrganization: false,
    deleteBranchStatus: false,
    deleteCameraStatus: false,
    deleteCameraGroupStatus: false,
    deleteWifiStatus: false,
    deleteQRCode: false,
    deleteNews: false,
    deleteNotification: false,
    deleteMeetingRoomStatus: false,
    deleteMeetingScheduleStatus: false,
    isUpdateMasterWorkShift: false,
    isUpdateOrganizationWorkShift: false,
    isUpdateEmployee: false,
    isUpdateDevice: false,
    isUpdateAssignedDevice: false,
    isUpdateLeave: false,
    isUpdateWorkDetail: false,
    isUpdatePlace: false,
    isUpdateArea: false,
    isUpdateCamera: false,
    isUpdateVipCustomer: false,
    isUpdateDetectUnknown: false,
    isClosePopupEmployee: false,
    isUpdateCheckInCheckOut: false,
    isUpdateInOut: false,
    isUpdateNewsEvent:false,
    isUpdatePermission: false,
    isUpdateAIRestricted: false,
    isUpdateFaceRecognition: false,
    isUpdateFaceRecognitionRegister: false,
    isUpdateOrgPackage: false,
    isUpdateOrgPackageRequestPackage: false,
    isUpdateHoliday: false,
    deleteDepartment: false,
    deleteNewsEvent: false,

    permissionsInfo: [],
    deleteComboService: false,
    deleteBeautyBooking: false,
    deleteNewsFeed: false,

    isUpdateNewKeywords: false,
    isDeleteWorkspace: false,
    isUpdateFile: false,
    isCalling: false,
    isBookingPopupOpen: false
};

export default state
